import { SVGProps } from 'react'

const HiperlinkIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.629 8.255a.386.386 0 0 0 .547 0l4.257-4.257a.387.387 0 0 0-.547-.547L3.629 7.708a.386.386 0 0 0 0 .547Z"
    />
    <path
      fill="currentColor"
      d="M6.424 8.371 4.92 9.876a2.06 2.06 0 0 1-2.912-2.912L3.513 5.46a.387.387 0 0 0-.546-.543L1.462 6.418a2.831 2.831 0 1 0 4.005 4.004l1.5-1.505a.387.387 0 1 0-.547-.547l.004.001ZM10.307 1.577a2.834 2.834 0 0 0-4.005 0l-1.5 1.504a.387.387 0 1 0 .548.548l1.504-1.505a2.058 2.058 0 0 1 2.907 2.91L8.257 6.54a.387.387 0 1 0 .546.543l1.504-1.505a2.835 2.835 0 0 0 0-4Z"
    />
  </svg>
)
export default HiperlinkIcon
